export default {
    manageAttendance: 'จัดการข้อมูลการลงเวลา',
    searchByEmployeeName: 'ค้นหาด้วยชื่อพนักงาน',
    search: 'ค้นหา',
    employeeName: 'ชื่อ - นามสกุล',
    group: 'กลุ่ม',
    department: 'แผนก',
    date: 'วันที่',
    checkIn: 'เข้างาน',
    status: 'สถานะ',
    action: 'แก้ไข',
    congratulation: 'ยินดีด้วย'
}
